import "./SubmittalPackages.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHeroSubmittals from "./sections/ServiceHeroSubmittals";
import SubmittalContents from "./sections/SubmittalContents";
import AvailableSubmittalPackages from "./sections/AvailableSubmittalPackages";
import WhySubmittalsMatter from "./sections/WhySubmittalsMatter";
import HowToAccess from "./sections/HowToAccess";
import CustomSubmittalSupport from "./sections/CustomSubmittalSupport";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SubmittalPackagesPage() {
  return <div>
      <Header />
      <ServiceHeroSubmittals />
      <SubmittalContents />
      <AvailableSubmittalPackages />
      <WhySubmittalsMatter />
      <HowToAccess />
      <CustomSubmittalSupport />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}